import React from 'react';

import * as i18n from 'i18next';
import {
  initReactI18next,
  useTranslation,
  Trans as I18nextTrans,
  TransProps,
} from 'react-i18next';

import de from '../../extractedTranslations/de/translation.json';
import en from '../../extractedTranslations/en/translation.json';
import es from '../../extractedTranslations/es/translation.json';
import fr from '../../extractedTranslations/fr/translation.json';
import id from '../../extractedTranslations/id/translation.json';
import it from '../../extractedTranslations/it/translation.json';
import ja from '../../extractedTranslations/ja/translation.json';
import ko from '../../extractedTranslations/ko/translation.json';
import pt from '../../extractedTranslations/pt/translation.json';
import th from '../../extractedTranslations/th/translation.json';
import vi from '../../extractedTranslations/vi/translation.json';
import zh from '../../extractedTranslations/zh-hans/translation.json';

const i18nInstance = i18n.createInstance().use(initReactI18next);

i18nInstance.init({
  resources: {
    en: { translation: en },
    pt: { translation: pt },
    es: { translation: es },
    de: { translation: de },
    zh: { translation: zh },
    fr: { translation: fr },
    th: { translation: th },
    id: { translation: id },
    it: { translation: it },
    ja: { translation: ja },
    ko: { translation: ko },
    vi: { translation: vi },
  },
  lng: 'en',
  fallbackLng: 'en',
  initImmediate: false,
  keySeparator: false,
  nsSeparator: false,
  returnEmptyString: false,
  interpolation: {
    escapeValue: false, // react already sanitises strings from xss
  },
});

export { i18nInstance as i18n };

const useTranslate = (
  ns: string | string[] | readonly string[] | undefined = undefined,
): CallableFunction =>
  useTranslation(ns, { i18n: i18nInstance, useSuspense: false }).t;

export const Trans = (props: TransProps<string>): React.ReactElement => (
  <I18nextTrans i18n={i18nInstance} {...props} /> // i18next-extract-disable-line
);

export default useTranslate;

export function setLanguage(lang: string): void {
  i18nInstance.changeLanguage(lang);
}
